<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <span v-if="mData.viewMode == 'create'">{{ aLang.c_create }} điểm đến</span>
        <span v-if="mData.viewMode == 'update'">{{ aLang.c_update }} điểm đến</span>
        <span v-if="mData.viewMode == 'detail'">{{ aLang.c_detail }} điểm đến</span>
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-form :model="mData.dataForm" :rules="mData.validForm" ref="myForm" label-width="100%" label-position="top">
          <b-row>
            <b-col md="4">
              <el-form-item label="Tên" prop="thong_tin_chung.ten">
                <el-input v-model="mData.dataForm.thong_tin_chung.ten" :disabled="mData.viewMode == 'detail'"
                  clearable></el-input>
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item label="Địa chỉ" prop="thong_tin_chung.dia_chi">
                <el-input v-model="mData.dataForm.thong_tin_chung.dia_chi" :disabled="mData.viewMode == 'detail'"
                  clearable></el-input>
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item label="Email" prop="thong_tin_chung.email">
                <el-input v-model="mData.dataForm.thong_tin_chung.email" :disabled="mData.viewMode == 'detail'"
                  clearable></el-input>
              </el-form-item>
            </b-col>
            <b-col md="2">
              <el-form-item label="Điện thoại" prop="thong_tin_chung.dien_thoai">
                <el-input v-model="mData.dataForm.thong_tin_chung.dien_thoai" :disabled="mData.viewMode == 'detail'"
                  clearable></el-input>
              </el-form-item>
            </b-col>
            <b-col md="2">
              <el-form-item label="Thành phố" prop="tinh_thanh">
                <!-- <el-input
                  v-model="mData.dataForm.tinh_thanh"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input> -->
                <el-select v-model="mData.dataForm.tinh_thanh" :placeholder="aLang.c_select"
                  :disabled="mData.viewMode == 'detail'" clearable filterable>
                  <el-option v-for="item in mData.dataDefault.listProvince" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="6">
              <el-form-item label="Website" prop="thong_tin_chung.website">
                <el-input v-model="mData.dataForm.thong_tin_chung.website" :disabled="mData.viewMode == 'detail'"
                  clearable></el-input>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4" lg="3" cols="12" v-for="item in mData.dataForm.thong_tin_chung.link_dich_vu" :key="item.id">
              <el-form-item :label="'Link ' + (item.ten ? item.ten : '')" prop="">
                <el-input v-model="item.link" :disabled="mData.viewMode == 'accept'" @input="forceUpdateUI"
                  clearable></el-input>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4" style="margin-bottom: 10px;">
              <el-form-item class="mb-3" label="Ảnh đại diện" prop="mediaId">
                <el-upload action :auto-upload="false" list-type="picture-card"
                  :limit="mData.fileUploadOption.AnhDaiDien.limit" :accept="mData.fileUploadOption.AnhDaiDien.accept"
                  :on-change="fn_uploadChangeAnhDaiDien" :on-preview="fn_uploadPreviewAnhDaiDien"
                  :on-remove="fn_uploadRemoveAnhDaiDien" :on-exceed="fn_uploadExceedAnhDaiDien"
                  :file-list="mData.fileUploadOption.AnhDaiDien.fileList" :disabled="mData.viewMode == 'detail'"
                  :class="[mData.fileUploadOption.AnhDaiDien.fileList.length > 0 ? 'hidden-icon-upload' : '']">
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :close-on-click-modal="true" :visible.sync="mData.fileUploadOption.AnhDaiDien.dialogVisible"
                  width="60%" top="51px" title="Chi tiết">
                  <img width="100%" :src="mData.fileUploadOption.AnhDaiDien.dialogImageUrl" alt />
                </el-dialog>
              </el-form-item>
            </b-col>
            <b-col md="8">
              <b-row>
                <b-col>
                  <el-form-item class="mb-0" label="Địa chỉ trên bản đồ">
                    <mapbox-component :viewMode="mData.viewMode" @update="fn_getDataFromMapboxComponent"
                      :cordinatesValue="mData.mapDataObject.value" :prop-disabled="mData.viewMode == 'detail'"
                      v-if="mData.dataDefault.showMap" id="mapBox"></mapbox-component>
                  </el-form-item>
                </b-col>
              </b-row>
            </b-col>
            <b-col md="12">
              <el-form-item label="Giới thiệu" prop="mo_ta">
                <CknoimgComponent v-model="mData.dataForm.mo_ta" :prop-data-editor-disabled="mData.viewMode == 'detail'"
                  @blur="handleBlur('mo_ta')"></CknoimgComponent>
              </el-form-item>
            </b-col>
            <b-col md="12">
              <el-form-item label="Mô tả" prop="chi_tiet">
                <CknoimgComponent v-model="mData.dataForm.chi_tiet"
                  :prop-data-editor-disabled="mData.viewMode == 'detail'" @blur="handleBlur('chi_tiet')">
                </CknoimgComponent>
              </el-form-item>
            </b-col>
          </b-row>
          <el-form-item class="text-center mt-3">
            <el-button type="info" plain @click="fn_submitForm('create')" v-ladda v-if="mData.viewMode == 'create'">{{
              aLang.c_create
            }}</el-button>

            <el-button type="info" plain @click="fn_submitForm('update')" v-ladda v-if="mData.viewMode == 'update'">{{
              aLang.c_update
            }}</el-button>

            <el-button @click="fn_go()" type="info" plain>{{ aLang.c_back }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from '../../../service/LanguageService';
import DataService from '@/service/DataService';
import MethodService from '../../../service/MethodService';
import DiemDenModel from './DiemDenModel';
import DiemDenApi from '../../../moduleApi/DiemDenApi';
import InfoDiemDenApi from '@/moduleApi/InfoDiemDenApi';
import ProvinceApi from '@/moduleApi/ProvinceApi';
import NenTangDichVuApi from '@/moduleApi/NenTangDichVuApi';
import ExtensionService from "../../../service/ExtensionService";
import CknoimgComponent from "../../../component/CknoimgComponent";
import MapboxComponent from "../../../component/MapboxComponent";
export default {
  components: {
    CknoimgComponent,
    MapboxComponent
  },
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        viewMode: "create",
        moduleName: "DiemDen",
        dataDefault: {
          showMap: false,
          listProvince: [],
          listNgonNgu: DataService.Languages,
          listHienThi: DataService.visibleList,
          listAccept: [
            {
              value: 0,
              label: 'Đã duyệt'
            },
            {
              value: 1,
              label: 'Chờ duyệt'
            },
            {
              value: 2,
              label: 'Từ chối'
            }
          ]
        },
        dataForm: MethodService.copyObject(DiemDenModel.dataForm),
        dataFormOther: MethodService.copyObject(DiemDenModel.dataFormOther),
        tableRules: MethodService.copyObject(DiemDenModel.tableRules),
        fileUploadOption: MethodService.copyObject(
          DiemDenModel.dataFormOther.fileUploadOption
        ),
        validForm: DiemDenModel.validForm,
        currentUser: JSON.parse(localStorage.getItem('currentUser')),
        ifHavePermission: false,
        dataPropMapDiaDiem: {
          fn_addLatLng: this.fn_addLatLngDiaDiem,
          lat: "",
          lng: "",
          showMap: false,
          id: "MapDiaDiem",
        },
        mapDataObject: {
          value: [105.850176, 21.0287797],
          geoJson: {
            type: "",
            coordinates: [],
          },
        },
      },
    };
  },
  async mounted() {
    let tinh_thanh = await ProvinceApi.list({
      limit: 1000
    });
    if (tinh_thanh.result) {
      this.mData.dataDefault.listProvince = tinh_thanh.result.map(item => {
        return { value: item.name, label: item.name }
      });
    }
  },
  async created() {

    if (this.mData.currentUser.id) {
      let dataFilter = {
        filters: 'nguoi_tao_id=' + this.mData.currentUser.id
      };
      let resInfoDiemDen = await InfoDiemDenApi.list(dataFilter);
      this.mData.tableRules.data.id = resInfoDiemDen.result[0].id;
      await this.fn_getDataById(this.mData.tableRules.data.id);
      if (
        !this.mData.dataForm.id
      ) {
        this.mData.viewMode = "create";
        let nen_tang_dich_vu = await NenTangDichVuApi.list({
          filters: "dich_vu=Điểm đến"
        });
        if (nen_tang_dich_vu.result) {
          for (let i = 0; i < nen_tang_dich_vu.result.length; i++) {
            nen_tang_dich_vu.result[i].link = "";
          }
        }
        this.mData.dataForm.thong_tin_chung.link_dich_vu = nen_tang_dich_vu.result;
      } else {
        this.mData.ifHavePermission = true;
        this.mData.viewMode = "update";
      }
    }
  },
  methods: {
    fn_submitForm(type) {
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          let data = MethodService.copyObject(this.mData.dataForm);
          if (type === "create") {
            data.thong_tin_chung.kinh_do = this.mData.mapDataObject.value[0];
            data.thong_tin_chung.vi_do = this.mData.mapDataObject.value[1];
            await DiemDenApi.create(data);
            this.fn_resetForm();
            this.$router.push({ name: "Admin-ThongTinDDAT-detail" });
          }
          if (type === "update") {
            data.id = this.mData.tableRules.data.id;
            data.duyet.duoc_duyet = 0;
            data.thong_tin_chung.kinh_do = this.mData.mapDataObject.value[0];
            data.thong_tin_chung.vi_do = this.mData.mapDataObject.value[1];
            await DiemDenApi.update(data);
            this.$router.push({ name: "Admin-ThongTinDDAT-detail" });
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    fn_resetForm() {
      this.mData.dataForm = MethodService.copyObject(
        DiemDenModel.dataForm
      );

      this.$refs["myForm"].resetFields();
    },

    async fn_getDataById(id) {
      let diem_den = await DiemDenApi.findById(id);
      let resForm = {};


      if (diem_den.result) {
        this.mData.dataForm = diem_den.result;
        if (diem_den.result.mediaId) {
          let data = {
            id: diem_den.result.mediaId,
            name: diem_den.result.mediaId,
            url: ExtensionService.urlImg + diem_den.result.mediaId
          };
          this.mData.fileUploadOption.AnhDaiDien.fileList.push(data);
        }
        if (
          diem_den.result.thong_tin_chung.kinh_do &&
          diem_den.result.thong_tin_chung.vi_do
        ) {
          this.mData.dataPropMapDiaDiem.lat = diem_den.result.thong_tin_chung.vi_do;
          this.mData.dataPropMapDiaDiem.lng = diem_den.result.thong_tin_chung.kinh_do;
          this.mData.dataPropMapDiaDiem.showMap = true;

          let coordinate = [
            diem_den.result.thong_tin_chung.kinh_do,
            diem_den.result.thong_tin_chung.vi_do,
          ];
          this.mData.mapDataObject.value = coordinate;
          this.mData.mapDataObject.geoJson.type = "Point";
          this.mData.mapDataObject.geoJson.coordinates = coordinate;
          this.mData.dataDefault.showMap = true;
        } else if (
          diem_den.result.thong_tin_chung.kinh_do == undefined &&
          diem_den.result.thong_tin_chung.vi_do == undefined
        ) {
          this.mData.dataForm.thong_tin_chung.kinh_do = 105.850176;
          this.mData.dataForm.thong_tin_chung.vi_do = 21.0287797;
          this.mData.dataDefault.showMap = true;
        }
        resForm.id = this.mData.dataForm.id;
        // if(this.mData.dataForm.thong_tin_chung.kinh_do == undefined && this.mData.dataForm.thong_tin_chung.vi_do == undefined){
        //   this.mData.dataForm.thong_tin_chung.kinh_do = 105.850176;
        //   this.mData.dataForm.thong_tin_chung.vi_do = 21.0287797;
        // }

      } else {
        this.$confirm(
          "Bạn chưa khai báo đầy đủ thông tin Đơn vị cung cấp, vui lòng khai báo trước khi truy cập tính năng này!",
          {
            confirmButtonText: LanguageService.lang.c_agree,
            showClose: false,
            showCancelButton: false,
            type: "warning",
          }
        )
          .then(() => {
            this.$router.push({
              name: "Admin-DiemDenForm-create",
              params: { id: resForm.id },
            });
            if (diem_den.result == undefined) {
              this.mData.dataForm.thong_tin_chung.kinh_do = 105.850176;
              this.mData.dataForm.thong_tin_chung.vi_do = 21.0287797;
              this.mData.dataDefault.showMap = true;
            }
          })

      }
    },

    fn_uploadRemoveAnhDaiDien() {
      this.mData.dataForm.mediaId = null;
      this.mData.fileUploadOption.AnhDaiDien.fileList = [];
      this.$refs["myForm"].validateField("mediaId");
    },
    fn_uploadChangeAnhDaiDien(file, fileList) {
      ExtensionService.upload(file, "diemDen")
        .then(res => {
          this.mData.dataForm.mediaId = res.result;
          this.mData.fileUploadOption.AnhDaiDien.fileList = fileList;
          this.$refs["myForm"].validateField("mediaId");
        })
        .catch(() => {
          this.$refs["myForm"].validateField("mediaId");
          fileList.forEach((el, i) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    fn_uploadExceedAnhDaiDien() {
      toastr.info(
        `Chỉ tải lên tối đa ${this.mData.fileUploadOption.AnhDaiDien.limit} file`
      );
    },
    fn_uploadPreviewAnhDaiDien(file) {
      this.mData.fileUploadOption.AnhDaiDien.dialogImageUrl = file.url;
      this.mData.fileUploadOption.AnhDaiDien.dialogVisible = true;
    },
    fn_getDataFromMapboxComponent(value) {
      this.mData.mapDataObject = value;
    },
    fn_go() {
      this.$router.go(-1);
    },
    handleBlur(prop) {
      this.$refs["myForm"].validateField(prop);
    },
    forceUpdateUI() {
      this.$forceUpdate();
    }
  }
}
</script>
